import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  linkFilesService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'revService',
    function (runtimeConstant, $http, $q, $filter, webApiSettings, Revision) {
      'use strict';

      var linkFilesServiceFactory = {};
      var filesToLink = [];
      var originalList = [];
      var isLinkingFiles = false;

      function handleError(err, status) {
        //falhou
        var error = {};
        if (status === 404 || status === -1) {
          error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };

          return error;
        }

        if (status === 403) {
          error = {
            error: $filter('translate')('NO PERMISSION'),
            error_description: $filter('translate')('USER LINK UNAUTHORIZED'),
          };

          return error;
        }

        if (status === 409) {
          error = {
            error: $filter('translate')('DOCUMENT ALREADY LINKED'),
            error_description: $filter('translate')(
              'ONE OR MORE DOCUMENTS IS ALREADY LINKED'
            ),
          };

          return error;
        }

        if (status === 401) {
          error = {
            error: $filter('translate')('ERROR'),
            error_description: $filter('translate')(
              'ONE OR MORE DOCUMENTS NOT FOUND'
            ),
          };

          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };

          return ex;
        }

        return err;
      }

      function update(idsToLink) {
        var mainRevision;
        this.filesToLink.forEach((f) => {
          if (f.isMainRevision) {
            mainRevision = f;
            return;
          }
        });

        var originalIds = [];
        this.originalList.forEach((f) => {
          originalIds.push(f.id);
        });

        var toSave = [];
        var toRemove = [];

        //aqui vou apenas adicionar novos documentos no vínculo já existente
        if (mainRevision.isOriginalMainRevision) {
          //os removidos serão os que estavam na lista original, mas não estão mais na nova lista...
          toRemove = originalIds.filter((el) => {
            return idsToLink.indexOf(el) < 0;
          });
          //os novos são os que estão na nova lista e não estão na lista originial =D
          var news = idsToLink.filter((el) => {
            return originalIds.indexOf(el) < 0;
          });

          news.forEach((f) => {
            var newLinked = {
              IdMainRevision: mainRevision.id,
              IdLinkedRevision: f,
            };
            toSave.push(newLinked);
          });
        } else {
          //o documento principal foi alterado
          this.filesToLink.forEach((f) => {
            if (!f.isMainRevision) {
              var newLinked = {
                IdMainRevision: mainRevision.id,
                IdLinkedRevision: f.id,
              };
              toSave.push(newLinked);
            }
          });
          //vou ter que excluir o vínculo atual para recria-lo novamente com o novo doc principal...
          toRemove = originalIds;
        }

        var updateModel = {
          NewLinkedRevisions: toSave,
          ToRemove: toRemove,
          IsUpdate: mainRevision.isOriginalMainRevision === true,
        };

        return $http.put(
          webApiSettings.apiServiceBaseUri + 'revisions/links/',
          updateModel,
          {
            ignoreLoadingBar: true,
          }
        );
      }

      function save() {
        var idsToLink = this.filesToLink.map((file) => file.id);
        var isEditing = this.originalList.length > 0;

        var webapiCall;

        if (isEditing) {
          webapiCall = linkFilesServiceFactory
            .update(idsToLink)
            .then(() => {
              var mainRevision = this.filesToLink.find(
                (file) => file.isMainRevision
              );

              var orderedLinkedRevisionIds = this.filesToLink
                .filter((file) => !file.isMainRevision)
                .map((file) => file.id);

              return linkFilesServiceFactory.reorder(
                mainRevision.id,
                orderedLinkedRevisionIds
              );
            });
        } else {
          webapiCall = $http.post(
            webApiSettings.apiServiceBaseUri + 'revisions/links/',
            idsToLink,
            {
              ignoreLoadingBar: true,
            }
          );
        }

        var deferred = $q.defer();

        webapiCall
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function cancel(ids) {
        var deferred = $q.defer();

        $http
          .delete(
            webApiSettings.apiServiceBaseUri +
              'revisions/links/?ids=' +
              ids.join('&ids=')
          )
          .then((result) => {
            var data = result.data;
            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function loadLinkedDocuments(id) {
        var deferred = $q.defer();
        //vou convencionar que quando a lista 'originalList' estiver nula, está carregando os docs vinculados da webapi
        linkFilesServiceFactory.originalList = null;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'revisions/links/' + id, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            var lst = result.data;
            lst = resolveReferences(lst);

            var linkedDocs = [];
            linkFilesServiceFactory.originalList = [];

            if (
              lst.ListLinkedRevisions !== undefined &&
              lst.ListLinkedRevisions !== null
            ) {
              var main = new Revision(lst.MainRevision);
              main.isMainRevision = true;
              main.isOriginalMainRevision = true;
              linkedDocs.push(main);
              linkFilesServiceFactory.originalList.push(main);

              lst.ListLinkedRevisions.forEach(function (c) {
                var rev = new Revision(c);
                linkedDocs.push(rev);
                linkFilesServiceFactory.originalList.push(rev);
              });
            }
            deferred.resolve(linkedDocs);
          })
          .catch((err) => {
            linkFilesServiceFactory.reset();
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function reset() {
        this.filesToLink = [];
        this.originalList = [];
        this.isLinkingFiles = false;
      }

      function isEditingLinks() {
        return this.originalList && this.originalList.length > 0;
      }

      function reorder(idMainRevision, orderedLinkedRevisionIds) {
        var deferred = $q.defer();

        $http
          .put(
            webApiSettings.apiServiceBaseUri + 'revisions/links/order',
            {
              idMainRevision: idMainRevision,
              orderedLinkedRevisionIds: orderedLinkedRevisionIds,
            },
            {
              ignoreLoadingBar: true,
            }
          )
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          linkFilesServiceFactory.filesToLink = filesToLink;
          linkFilesServiceFactory.originalList = originalList;
          linkFilesServiceFactory.isLinkingFiles = isLinkingFiles;

          linkFilesServiceFactory.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.update = logWrapper(
            update,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.reset = logWrapper(
            reset,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.loadLinkedDocuments = logWrapper(
            loadLinkedDocuments,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.isEditingLinks = logWrapper(
            isEditingLinks,
            runtimeConstant.isDebugServicesInternals
          );
          linkFilesServiceFactory.reorder = logWrapper(
            reorder,
            runtimeConstant.isDebugServicesInternals
          );

          return linkFilesServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
